/** Read saved answers without rewriting historical events during configuration upgrades. */
export function recordFieldValue(record, fieldId, domain) {
  if (record?.[fieldId] !== undefined) return record[fieldId];
  if (record?.fieldValues?.[fieldId] !== undefined) return record.fieldValues[fieldId];
  const primary = domain?.primary;
  if (fieldId !== primary?.id) return undefined;
  if (primary.type === 'number') return record?.numericValue ?? record?.score;
  // Choice writers already use the option's stable id as typeId. Old type-only
  // records can therefore retain their meaning after those same ids are adopted
  // into the primary field. Unknown ids never become invented answers.
  if (primary.type === 'multiChoice' && record?.typeId != null
    && primary.options?.some(option => String(option.value) === String(record.typeId))) {
    return record.typeId;
  }
  return undefined;
}

export function projectRecordPrimaryValue(record, domain) {
  const id = domain?.primary?.id;
  if (!id || record[id] !== undefined || record.fieldValues?.[id] !== undefined) return record;
  const value = recordFieldValue(record, id, domain);
  return value === undefined ? record : { ...record, [id]: value };
}
